import React from 'react';
import { CalendarDaysIcon, MapIcon } from '@heroicons/react/24/outline';

export default function ViewToggle({ view, onChange }) {
  return (
    <div className="inline-flex rounded border border-gray-300 divide-x divide-gray-300">
      <button
        onClick={() => onChange('calendar')}
        className={`flex items-center gap-1.5 px-3 py-1 text-sm font-medium transition-colors rounded-l ${
          view === 'calendar'
            ? 'bg-gray-100 text-gray-900'
            : 'text-gray-600 hover:bg-gray-100'
        }`}
      >
        <CalendarDaysIcon className="h-4 w-4" />
        Calendar
      </button>
      <button
        onClick={() => onChange('map')}
        className={`flex items-center gap-1.5 px-3 py-1 text-sm font-medium transition-colors rounded-r ${
          view === 'map'
            ? 'bg-gray-100 text-gray-900'
            : 'text-gray-600 hover:bg-gray-100'
        }`}
      >
        <MapIcon className="h-4 w-4" />
        Map
      </button>
    </div>
  );
}
